export default __webpack_public_path__ + "CV_Linkpick.04e0de2.png";